import { useEffect, useState } from "react";
import { feedbackQuery } from "./supabaseHelper";
import { AlertCircle } from "lucide-react";

interface Props {
  title: string;
  type: string;
}

export default function DuplicateHints({ title, type }: Props) {
  const [hints, setHints] = useState<{ id: string; title: string; vote_count: number }[]>([]);

  useEffect(() => {
    if (title.length < 4) {
      setHints([]);
      return;
    }
    const timeout = setTimeout(async () => {
      const keywords = title.split(/\s+/).filter((w) => w.length > 2).slice(0, 3);
      if (!keywords.length) return;

      const { data } = await feedbackQuery("feedback_items")
        .select("id, title, vote_count")
        .is("deleted_at", null)
        .in("status", ["open", "in_review", "planned", "in_progress"])
        .ilike("title", `%${keywords[0]}%`)
        .limit(5);

      setHints(data ?? []);
    }, 400);

    return () => clearTimeout(timeout);
  }, [title, type]);

  if (!hints.length) return null;

  return (
    <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-3">
      <div className="mb-2 flex items-center gap-2 text-xs font-medium text-amber-400">
        <AlertCircle className="h-3.5 w-3.5" />
        Similar existing reports:
      </div>
      <ul className="space-y-1">
        {hints.map((h) => (
          <li key={h.id} className="text-xs text-muted-foreground">
            • {h.title} ({h.vote_count} votes)
          </li>
        ))}
      </ul>
    </div>
  );
}
